@use '@design/components/custom-scroll/custom-scroll' as *;
@use '@design/design-tokens/typography/typography' as *;

.root {
 overflow-x: auto;
 @include custom-scroll-minimal;
}

.textCell {
  @include typography-v2-body-sm;
  white-space: normal;
}

.priceChange {
  flex-direction: column;
  align-items: flex-end;
}
